import { render, staticRenderFns } from "./SsoLanding.vue?vue&type=template&id=26b17016&scoped=true&"
import script from "./SsoLanding.vue?vue&type=script&lang=js&"
export * from "./SsoLanding.vue?vue&type=script&lang=js&"
import style0 from "./SsoLanding.vue?vue&type=style&index=0&id=26b17016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b17016",
  null
  
)

export default component.exports